<section #multiChartContainer id="multiChartContainer" class="chart-container">
	<div *ngFor="let chartModel of multiChartModels" class="mobile-chart-container">
		<div class="top-break"></div>
		<div *ngIf="chartModel.highChartsAttributes.customAttributes && chartModel.highChartsAttributes.customAttributes.categoryFilter" class="mobile-chart-title">
			<span>{{ chartModel.highChartsAttributes.customAttributes.categoryFilter }}</span>
		</div>
		<ac-chart [highChartsAttributes]="chartModel.highChartsAttributes"></ac-chart>
	</div>
</section>
